import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, Row, Col, Typography, Space } from 'antd';
import { TeamOutlined, UserOutlined, PhoneOutlined, StopOutlined, ImportOutlined } from '@ant-design/icons';
import './styles.css';

const { Title, Text } = Typography;

const Config: React.FC = () => {
  const navigate = useNavigate();

  const configItems = [
    {
      icon: <UserOutlined style={{ fontSize: 24 }} />,
      title: '用户管理',
      description: '管理系统用户，设置权限和角色',
      path: '/config/users',
      color: '#52c41a',
    },
    {
      icon: <TeamOutlined style={{ fontSize: 24 }} />,
      title: '用户分组管理',
      description: '管理用户分组，设置分组成员',
      path: '/config/user-groups',
      color: '#1890ff',
    },
    {
      icon: <PhoneOutlined style={{ fontSize: 24 }} />,
      title: '外呼管理',
      description: '管理外呼座席，查看外呼统计',
      path: '/config/outbound-seats',
      color: '#fa8c16',
    },
    {
      icon: <StopOutlined style={{ fontSize: 24 }} />,
      title: '黑名单管理',
      description: '管理手机号黑名单，查看拉黑记录',
      path: '/config/phone-blacklist',
      color: '#ff4d4f',
    },
    {
      icon: <ImportOutlined style={{ fontSize: 24 }} />,
      title: '线索导入',
      description: '批量导入线索数据到系统，查看导入历史',
      path: '/config/lead-import',
      color: '#722ed1',
    },
  ];

  const handleCardClick = (path: string) => {
    navigate(path);
  };

  return (
    <div style={{ padding: 24 }}>
      <Space direction="vertical" size={24} style={{ width: '100%' }}>
        <div>
          <Title level={3}>配置中心</Title>
          <Text type="secondary">管理系统配置和用户权限</Text>
        </div>

        <Row gutter={[16, 16]}>
          {configItems.map((item, index) => (
            <Col xs={24} sm={12} lg={6} key={index}>
              <Card
                hoverable
                onClick={() => handleCardClick(item.path)}
                style={{ height: '100%' }}
              >
                <Space direction="vertical" size={12} style={{ width: '100%' }}>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      width: 48,
                      height: 48,
                      borderRadius: 8,
                      backgroundColor: `${item.color}15`,
                      color: item.color,
                    }}
                  >
                    {item.icon}
                  </div>
                  <div>
                    <Title level={5} style={{ marginBottom: 4 }}>
                      {item.title}
                    </Title>
                    <Text type="secondary">{item.description}</Text>
                  </div>
                </Space>
              </Card>
            </Col>
          ))}
        </Row>
      </Space>
    </div>
  );
};

export default Config;